module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//box.png?v=ccb409c5";